interface ILeapHomeContainerProps {
  content: JSX.Element;
}

const CircularEconomyHomeContainer = ({ content }: ILeapHomeContainerProps) => (
  <div className="container">{content}</div>
);

export default CircularEconomyHomeContainer;
